
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as helpGvNgDfnCbSjEPkiZzs20efQudSIu8OfvaW30F7kfOIUMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/help.vue?macro=true";
import { default as indexJwBpjoBX4OPPvG8ah6Yn6KFoy6qK_45WGL3F7XcqKR1toMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/index.vue?macro=true";
import { default as login_451wlHGpV1TiIiMXQXhC3RnXPCa9YeUyR9ymR000nrvUMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/login.vue?macro=true";
import { default as logoutSGGVtPnRp4YGl178In_45hv_45CGfMhYNWuJIdTgZePt4BEMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/logout.vue?macro=true";
import { default as privacyDUBWx8a0SXLB_YDRAIOdh1_45ZnV5FplCK8cM_45KgU_6pYMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/privacy.vue?macro=true";
import { default as newObX8cIci43mQ9imJd5A3AtqxMTzPSJ35AAx0MDU2xLEMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/rie/new.vue?macro=true";
import { default as index8fG55j0oNWJ556gZIltx9TNB0306W6cti5XuIz60pnYMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/rie/index.vue?macro=true";
import { default as editVMG872MkWE4SmfE_pt9vx7P7qMTu9VEb27xQrvsYpoUMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/rie/[rieId]/edit.vue?macro=true";
import { default as indexHaD8QoVcaWmI7t0_wLPnBQZOee_45I3btFLTD8NmdPNFYMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/rie/[rieId]/index.vue?macro=true";
import { default as riedCFAJtrrK_45ekmf1Hd7c_3hZag3m2T2x64TtErvjufggMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/rie.vue?macro=true";
import { default as indexux9qc62jX5FMuoK4fopPM7k5qgLrVbjYsoGHSn_45mKLgMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/index.vue?macro=true";
import { default as indexd8e64Gl4lYlz7h86HcnqoWikjxTauOnLc4jRb_45Zu66kMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/risicos/index.vue?macro=true";
import { default as edit4dpQO1oiL93zdJj2n_45ipGYmecCGPXhPT2r8ZZEHQunMMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/edit.vue?macro=true";
import { default as indexF4Z1_xlx_M8G_45NycncXyktfoDW_45cy9_45f69QmWW0tNeYMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/index.vue?macro=true";
import { default as risicos1bOUn5huMK6uKmhLXcMyDWlhmgcORFnuzAipLPMgkSQMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/risicos.vue?macro=true";
import { default as dashboardm7jErTjwhVgZItaTDsTCeNckRB4Zz8WyCjKaSsDqlpsMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/dashboard.vue?macro=true";
import { default as indexKrVgMxgDK6g_hVoUYWrbN5loqcCxkM2GcTrJZqg_457SYMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/rapportage/index.vue?macro=true";
import { default as aanmakenIZV7Yz8pfB697MvQRxjQJWgEMoIdU7kE7D5YQ6VeL8YMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/rapportage/aanmaken.vue?macro=true";
import { default as rapportageP7B0wd2od8ojyVCni31VuG2huors2ClxLvMhb1_9GqcMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/rapportage.vue?macro=true";
import { default as indexYbV3rEnrQpsviAoESPtvV_455jfGO6F14ww5SjiXhpGikMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie/index.vue?macro=true";
import { default as onderwerpenfWccVJFGvQjAVoKCS0cCbooGulecAhqa9RfSUPdS3EoMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie/onderwerpen.vue?macro=true";
import { default as endDdGDNCNujc1E5dA99OfUMhxdrlO0ioqarTon2QFKDA0Meta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/end.vue?macro=true";
import { default as indexjcjc_DTKsO3qdnGWCSHrOHaZAYiv0PagjdH2X1wqlDIMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/index.vue?macro=true";
import { default as _91questionKey_93YdKsU52c9hmIEzJUayTr3zCjquPbtKmHqmdcnS_yL_0Meta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/[questionKey].vue?macro=true";
import { default as inventarisatieA_K3w5CK7KVZ9QwOMCJEOXrRrsVyhUvi43LWUQkzwHwMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie.vue?macro=true";
import { default as indexqIzDc_A35J7irV84eTQeiXg4q47yS24w9W06iHwrXGgMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/index.vue?macro=true";
import { default as editXnBoMttm1g4XjXdxE38mm1_45k7cyT9poavi0icG8BXS4Meta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/edit.vue?macro=true";
import { default as indexkpBogoOSZ2_45w17egwcCU450FpGbHrgHEmYM_H64eH5MMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/index.vue?macro=true";
import { default as plan_45van_45aanpakoBSuY6osQpGkLQdxX9lMHm9bgJaIU3MJKgIGEoEHEm4Meta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/plan-van-aanpak.vue?macro=true";
import { default as indexeEujgdlKaBB5_45At_45GZqC0ZqM8_ooJNjAniZBr_C1KNwMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/stigas/werknemersvragenlijst/index.vue?macro=true";
import { default as _91rieId_93xkb5IsI8bgGPR4eEHsHwPqvTDxhUgKCEEZWnnVGzULkMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId].vue?macro=true";
import { default as index7WHvbsDyH7NmcxJ03D_45YFhFkxH3Q22JlLcgjR8IjmEAMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/gebruikers/index.vue?macro=true";
import { default as _91userId_93QQp6FrTsZhX2x3PKoJnYAyZXbcHj6fDk2K4g1hjMUmwMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/gebruikers/[userId].vue?macro=true";
import { default as uitnodigenrFegstNEo8SgS98yWWPXvYH9maDNXxPxkBPES51MLzUMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/gebruikers/uitnodigen.vue?macro=true";
import { default as gebruikersPQmQ9z5vVR_SI4wItz_45rQC3zFsxLrQwDFtc4ms2jOmoMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/gebruikers.vue?macro=true";
import { default as editeoJUmTLRARkWblXo7U4jcHBM29ZUa7kViSG5h_45FLZecMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/bedrijfsinformatie/edit.vue?macro=true";
import { default as indexS_45S4SurCeyXNF02dkvk8eDX5qmTlong2Dkh6WLlsK6QMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/bedrijfsinformatie/index.vue?macro=true";
import { default as bedrijfsinformatieujK_ABKh8i7jIRaNCSxECe5GrP0_45BuZT6N8EuOApeWkMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/bedrijfsinformatie.vue?macro=true";
import { default as _91id_93ErxVfEnjGOsWVOQDIk6FmgSOqNhUjqikd4kyIO7szckMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/verantwoordelijken/[id].vue?macro=true";
import { default as indexTrIVVquNhQj_NRNh_mmG_FoORsmLh3zyV9p3tiZcj7EMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/verantwoordelijken/index.vue?macro=true";
import { default as verantwoordelijkeniZoQt51KOPLt97y7TuX0Kznm52cqFELeRViqSAi8ZKgMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/verantwoordelijken.vue?macro=true";
import { default as newZX8Pu2A2NoSHWM4rN4QZVjDFXwwy4azXQxuqP7W4_WwMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/new.vue?macro=true";
import { default as indexfYCHF823J30B2lcIYyJAT9C5tc3at0jeldLNM_TvbbQMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/index.vue?macro=true";
import { default as editDNtpRErhPUE23a9haLlEuyzw2Vxl_i1M_45fswD8R7fncMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/edit.vue?macro=true";
import { default as indexyDDEYpnrtuuYPelNT1cgdWHfuz6aoaxNJtUqoHx80yIMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/index.vue?macro=true";
import { default as _91accidentId_9303zQUiQMDrDMNXDjfFn7qlKPPtiKT_45QkQzMkGMUbF1gMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/[accidentId].vue?macro=true";
import { default as achtergrondinformatieMgO7xy5Q83X8KG61n0M2X1D_DMDh7PYfK_45Bvgw6_45FvMMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/achtergrondinformatie.vue?macro=true";
import { default as ongevallenregistratieETVbhwoMR_5ic7DD9jLjZBckTdd1tA5oGjOGu8qLLZcMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie.vue?macro=true";
import { default as _91companyId_93xOoRnpeJCffG6OKjg0xN_45mrKDaaEDesWeQeSzjFyLZ8Meta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId].vue?macro=true";
import { default as request_45link0CXxM1pI1K4nNYVTKY20eOQiYRT_456Ht58LKtnkKH3h8Meta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/request-link.vue?macro=true";
import { default as new6b8AdyfiR38kfuAL8xnIMGbtocxpU0XPBB7ML2M0oFQMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/companies/new.vue?macro=true";
import { default as manage_45catalogshSp7yKuGbuMFG4qti1qAOUwnYbwjiEq2v_UmuS41R8Meta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/manage-catalog.vue?macro=true";
import { default as index7Z7Pdu_45bEQXxfuOOXte4Co4zxg_45pHnpn7tSNs6CepM8Meta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/companies/index.vue?macro=true";
import { default as edithiHaxw3g6E0QPjKZBvARE8M08M32O0W5Hkt6G_DGkOkMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/persoonsgegevens/edit.vue?macro=true";
import { default as indexXrIDYqatrrO_Boyabrwz6YrTQ26KeEqUbu2cR3SkeqgMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/persoonsgegevens/index.vue?macro=true";
import { default as persoonsgegevenshweZKAZOamoEOkinq7ja2onO7pi6SalfwOZsViHOxHgMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/persoonsgegevens.vue?macro=true";
import { default as vragenlijstPrRY_45osR_45w3XJplx_EB_45WYRoGuDuF_TDVKYtLJICbVIMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/stigas/vragenlijst.vue?macro=true";
import { default as voorwaarden_45afgewezenKo1wb1SCeeJ_k9d13RcFZQcOg9fbcqvu6NmMKAgVy60Meta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/voorwaarden-afgewezen.vue?macro=true";
import { default as indexfcJaxBh0_45vWRcOjRkHMHFaseGahTYzjRcf6YCGjBkOMMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/application-users/index.vue?macro=true";
import { default as _91userId_93S1AZnTCYuNL7lpifbg2_4503IbEPIY9NpukSSfDq03RoAMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/application-users/[userId].vue?macro=true";
import { default as uitnodigenRuZkInJwZHOHaME8B68_1hqT5G3N9hH7PCEMs6h9oEgMeta } from "/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/application-users/uitnodigen.vue?macro=true";
export default [
  {
    name: helpGvNgDfnCbSjEPkiZzs20efQudSIu8OfvaW30F7kfOIUMeta?.name ?? "help",
    path: "/help",
    meta: helpGvNgDfnCbSjEPkiZzs20efQudSIu8OfvaW30F7kfOIUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/help.vue")
  },
  {
    name: indexJwBpjoBX4OPPvG8ah6Yn6KFoy6qK_45WGL3F7XcqKR1toMeta?.name ?? "index",
    path: "/",
    meta: indexJwBpjoBX4OPPvG8ah6Yn6KFoy6qK_45WGL3F7XcqKR1toMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/index.vue")
  },
  {
    name: login_451wlHGpV1TiIiMXQXhC3RnXPCa9YeUyR9ymR000nrvUMeta?.name ?? "login",
    path: "/login",
    meta: login_451wlHGpV1TiIiMXQXhC3RnXPCa9YeUyR9ymR000nrvUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/login.vue")
  },
  {
    name: logoutSGGVtPnRp4YGl178In_45hv_45CGfMhYNWuJIdTgZePt4BEMeta?.name ?? "logout",
    path: "/logout",
    meta: logoutSGGVtPnRp4YGl178In_45hv_45CGfMhYNWuJIdTgZePt4BEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/logout.vue")
  },
  {
    name: privacyDUBWx8a0SXLB_YDRAIOdh1_45ZnV5FplCK8cM_45KgU_6pYMeta?.name ?? "privacy",
    path: "/privacy",
    meta: privacyDUBWx8a0SXLB_YDRAIOdh1_45ZnV5FplCK8cM_45KgU_6pYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/privacy.vue")
  },
  {
    name: _91companyId_93xOoRnpeJCffG6OKjg0xN_45mrKDaaEDesWeQeSzjFyLZ8Meta?.name,
    path: "/:companyId()",
    meta: _91companyId_93xOoRnpeJCffG6OKjg0xN_45mrKDaaEDesWeQeSzjFyLZ8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId].vue"),
    children: [
  {
    name: riedCFAJtrrK_45ekmf1Hd7c_3hZag3m2T2x64TtErvjufggMeta?.name,
    path: "rie",
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/rie.vue"),
    children: [
  {
    name: newObX8cIci43mQ9imJd5A3AtqxMTzPSJ35AAx0MDU2xLEMeta?.name ?? "companyId-rie-new",
    path: "new",
    meta: newObX8cIci43mQ9imJd5A3AtqxMTzPSJ35AAx0MDU2xLEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/rie/new.vue")
  },
  {
    name: index8fG55j0oNWJ556gZIltx9TNB0306W6cti5XuIz60pnYMeta?.name ?? "companyId-rie",
    path: "",
    meta: index8fG55j0oNWJ556gZIltx9TNB0306W6cti5XuIz60pnYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/rie/index.vue")
  },
  {
    name: editVMG872MkWE4SmfE_pt9vx7P7qMTu9VEb27xQrvsYpoUMeta?.name ?? "companyId-rie-rieId-edit",
    path: ":rieId()/edit",
    meta: editVMG872MkWE4SmfE_pt9vx7P7qMTu9VEb27xQrvsYpoUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/rie/[rieId]/edit.vue")
  },
  {
    name: indexHaD8QoVcaWmI7t0_wLPnBQZOee_45I3btFLTD8NmdPNFYMeta?.name ?? "companyId-rie-rieId",
    path: ":rieId()",
    meta: indexHaD8QoVcaWmI7t0_wLPnBQZOee_45I3btFLTD8NmdPNFYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/rie/[rieId]/index.vue")
  }
]
  },
  {
    name: indexux9qc62jX5FMuoK4fopPM7k5qgLrVbjYsoGHSn_45mKLgMeta?.name ?? "companyId",
    path: "",
    meta: indexux9qc62jX5FMuoK4fopPM7k5qgLrVbjYsoGHSn_45mKLgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/index.vue")
  },
  {
    name: "companyId-rieId",
    path: ":rieId()",
    meta: _91rieId_93xkb5IsI8bgGPR4eEHsHwPqvTDxhUgKCEEZWnnVGzULkMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId].vue"),
    children: [
  {
    name: risicos1bOUn5huMK6uKmhLXcMyDWlhmgcORFnuzAipLPMgkSQMeta?.name,
    path: "risicos",
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/risicos.vue"),
    children: [
  {
    name: indexd8e64Gl4lYlz7h86HcnqoWikjxTauOnLc4jRb_45Zu66kMeta?.name ?? "companyId-rieId-risicos",
    path: "",
    meta: indexd8e64Gl4lYlz7h86HcnqoWikjxTauOnLc4jRb_45Zu66kMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/risicos/index.vue")
  },
  {
    name: edit4dpQO1oiL93zdJj2n_45ipGYmecCGPXhPT2r8ZZEHQunMMeta?.name ?? "companyId-rieId-risicos-riskId-edit",
    path: ":riskId()/edit",
    meta: edit4dpQO1oiL93zdJj2n_45ipGYmecCGPXhPT2r8ZZEHQunMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/edit.vue")
  },
  {
    name: indexF4Z1_xlx_M8G_45NycncXyktfoDW_45cy9_45f69QmWW0tNeYMeta?.name ?? "companyId-rieId-risicos-riskId",
    path: ":riskId()",
    meta: indexF4Z1_xlx_M8G_45NycncXyktfoDW_45cy9_45f69QmWW0tNeYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/index.vue")
  }
]
  },
  {
    name: dashboardm7jErTjwhVgZItaTDsTCeNckRB4Zz8WyCjKaSsDqlpsMeta?.name ?? "companyId-rieId-dashboard",
    path: "dashboard",
    meta: dashboardm7jErTjwhVgZItaTDsTCeNckRB4Zz8WyCjKaSsDqlpsMeta || {},
    alias: ["","dashboard"],
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/dashboard.vue")
  },
  {
    name: rapportageP7B0wd2od8ojyVCni31VuG2huors2ClxLvMhb1_9GqcMeta?.name,
    path: "rapportage",
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/rapportage.vue"),
    children: [
  {
    name: indexKrVgMxgDK6g_hVoUYWrbN5loqcCxkM2GcTrJZqg_457SYMeta?.name ?? "companyId-rieId-rapportage",
    path: "",
    meta: indexKrVgMxgDK6g_hVoUYWrbN5loqcCxkM2GcTrJZqg_457SYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/rapportage/index.vue")
  },
  {
    name: aanmakenIZV7Yz8pfB697MvQRxjQJWgEMoIdU7kE7D5YQ6VeL8YMeta?.name ?? "companyId-rieId-rapportage-aanmaken",
    path: "aanmaken",
    meta: aanmakenIZV7Yz8pfB697MvQRxjQJWgEMoIdU7kE7D5YQ6VeL8YMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/rapportage/aanmaken.vue")
  }
]
  },
  {
    name: inventarisatieA_K3w5CK7KVZ9QwOMCJEOXrRrsVyhUvi43LWUQkzwHwMeta?.name,
    path: "inventarisatie",
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie.vue"),
    children: [
  {
    name: indexYbV3rEnrQpsviAoESPtvV_455jfGO6F14ww5SjiXhpGikMeta?.name ?? "companyId-rieId-inventarisatie",
    path: "",
    meta: indexYbV3rEnrQpsviAoESPtvV_455jfGO6F14ww5SjiXhpGikMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie/index.vue")
  },
  {
    name: onderwerpenfWccVJFGvQjAVoKCS0cCbooGulecAhqa9RfSUPdS3EoMeta?.name ?? "companyId-rieId-inventarisatie-onderwerpen",
    path: "onderwerpen",
    meta: onderwerpenfWccVJFGvQjAVoKCS0cCbooGulecAhqa9RfSUPdS3EoMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie/onderwerpen.vue")
  },
  {
    name: endDdGDNCNujc1E5dA99OfUMhxdrlO0ioqarTon2QFKDA0Meta?.name ?? "companyId-rieId-inventarisatie-topicKey-end",
    path: ":topicKey()/end",
    meta: endDdGDNCNujc1E5dA99OfUMhxdrlO0ioqarTon2QFKDA0Meta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/end.vue")
  },
  {
    name: indexjcjc_DTKsO3qdnGWCSHrOHaZAYiv0PagjdH2X1wqlDIMeta?.name ?? "companyId-rieId-inventarisatie-topicKey",
    path: ":topicKey()",
    meta: indexjcjc_DTKsO3qdnGWCSHrOHaZAYiv0PagjdH2X1wqlDIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/index.vue")
  },
  {
    name: _91questionKey_93YdKsU52c9hmIEzJUayTr3zCjquPbtKmHqmdcnS_yL_0Meta?.name ?? "companyId-rieId-inventarisatie-topicKey-questionKey",
    path: ":topicKey()/:questionKey()",
    meta: _91questionKey_93YdKsU52c9hmIEzJUayTr3zCjquPbtKmHqmdcnS_yL_0Meta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/[questionKey].vue")
  }
]
  },
  {
    name: plan_45van_45aanpakoBSuY6osQpGkLQdxX9lMHm9bgJaIU3MJKgIGEoEHEm4Meta?.name,
    path: "plan-van-aanpak",
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/plan-van-aanpak.vue"),
    children: [
  {
    name: indexqIzDc_A35J7irV84eTQeiXg4q47yS24w9W06iHwrXGgMeta?.name ?? "companyId-rieId-plan-van-aanpak",
    path: "",
    meta: indexqIzDc_A35J7irV84eTQeiXg4q47yS24w9W06iHwrXGgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/index.vue")
  },
  {
    name: editXnBoMttm1g4XjXdxE38mm1_45k7cyT9poavi0icG8BXS4Meta?.name ?? "companyId-rieId-plan-van-aanpak-actionId-edit",
    path: ":actionId()/edit",
    meta: editXnBoMttm1g4XjXdxE38mm1_45k7cyT9poavi0icG8BXS4Meta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/edit.vue")
  },
  {
    name: indexkpBogoOSZ2_45w17egwcCU450FpGbHrgHEmYM_H64eH5MMeta?.name ?? "companyId-rieId-plan-van-aanpak-actionId",
    path: ":actionId()",
    meta: indexkpBogoOSZ2_45w17egwcCU450FpGbHrgHEmYM_H64eH5MMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/index.vue")
  }
]
  },
  {
    name: indexeEujgdlKaBB5_45At_45GZqC0ZqM8_ooJNjAniZBr_C1KNwMeta?.name ?? "companyId-rieId-stigas-werknemersvragenlijst",
    path: "stigas/werknemersvragenlijst",
    meta: indexeEujgdlKaBB5_45At_45GZqC0ZqM8_ooJNjAniZBr_C1KNwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/[rieId]/stigas/werknemersvragenlijst/index.vue")
  }
]
  },
  {
    name: gebruikersPQmQ9z5vVR_SI4wItz_45rQC3zFsxLrQwDFtc4ms2jOmoMeta?.name,
    path: "gebruikers",
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/gebruikers.vue"),
    children: [
  {
    name: index7WHvbsDyH7NmcxJ03D_45YFhFkxH3Q22JlLcgjR8IjmEAMeta?.name ?? "companyId-gebruikers",
    path: "",
    meta: index7WHvbsDyH7NmcxJ03D_45YFhFkxH3Q22JlLcgjR8IjmEAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/gebruikers/index.vue")
  },
  {
    name: _91userId_93QQp6FrTsZhX2x3PKoJnYAyZXbcHj6fDk2K4g1hjMUmwMeta?.name ?? "companyId-gebruikers-userId",
    path: ":userId()",
    meta: _91userId_93QQp6FrTsZhX2x3PKoJnYAyZXbcHj6fDk2K4g1hjMUmwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/gebruikers/[userId].vue")
  },
  {
    name: uitnodigenrFegstNEo8SgS98yWWPXvYH9maDNXxPxkBPES51MLzUMeta?.name ?? "companyId-gebruikers-uitnodigen",
    path: "uitnodigen",
    meta: uitnodigenrFegstNEo8SgS98yWWPXvYH9maDNXxPxkBPES51MLzUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/gebruikers/uitnodigen.vue")
  }
]
  },
  {
    name: bedrijfsinformatieujK_ABKh8i7jIRaNCSxECe5GrP0_45BuZT6N8EuOApeWkMeta?.name,
    path: "bedrijfsinformatie",
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/bedrijfsinformatie.vue"),
    children: [
  {
    name: editeoJUmTLRARkWblXo7U4jcHBM29ZUa7kViSG5h_45FLZecMeta?.name ?? "companyId-bedrijfsinformatie-edit",
    path: "edit",
    meta: editeoJUmTLRARkWblXo7U4jcHBM29ZUa7kViSG5h_45FLZecMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/bedrijfsinformatie/edit.vue")
  },
  {
    name: indexS_45S4SurCeyXNF02dkvk8eDX5qmTlong2Dkh6WLlsK6QMeta?.name ?? "companyId-bedrijfsinformatie",
    path: "",
    meta: indexS_45S4SurCeyXNF02dkvk8eDX5qmTlong2Dkh6WLlsK6QMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/bedrijfsinformatie/index.vue")
  }
]
  },
  {
    name: verantwoordelijkeniZoQt51KOPLt97y7TuX0Kznm52cqFELeRViqSAi8ZKgMeta?.name,
    path: "verantwoordelijken",
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/verantwoordelijken.vue"),
    children: [
  {
    name: _91id_93ErxVfEnjGOsWVOQDIk6FmgSOqNhUjqikd4kyIO7szckMeta?.name ?? "companyId-verantwoordelijken-id",
    path: ":id()",
    meta: _91id_93ErxVfEnjGOsWVOQDIk6FmgSOqNhUjqikd4kyIO7szckMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/verantwoordelijken/[id].vue")
  },
  {
    name: indexTrIVVquNhQj_NRNh_mmG_FoORsmLh3zyV9p3tiZcj7EMeta?.name ?? "companyId-verantwoordelijken",
    path: "",
    meta: indexTrIVVquNhQj_NRNh_mmG_FoORsmLh3zyV9p3tiZcj7EMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/verantwoordelijken/index.vue")
  }
]
  },
  {
    name: ongevallenregistratieETVbhwoMR_5ic7DD9jLjZBckTdd1tA5oGjOGu8qLLZcMeta?.name,
    path: "ongevallenregistratie",
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie.vue"),
    children: [
  {
    name: newZX8Pu2A2NoSHWM4rN4QZVjDFXwwy4azXQxuqP7W4_WwMeta?.name ?? "companyId-ongevallenregistratie-new",
    path: "new",
    meta: newZX8Pu2A2NoSHWM4rN4QZVjDFXwwy4azXQxuqP7W4_WwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/new.vue")
  },
  {
    name: indexfYCHF823J30B2lcIYyJAT9C5tc3at0jeldLNM_TvbbQMeta?.name ?? "companyId-ongevallenregistratie",
    path: "",
    meta: indexfYCHF823J30B2lcIYyJAT9C5tc3at0jeldLNM_TvbbQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/index.vue")
  },
  {
    name: _91accidentId_9303zQUiQMDrDMNXDjfFn7qlKPPtiKT_45QkQzMkGMUbF1gMeta?.name,
    path: ":accidentId()",
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/[accidentId].vue"),
    children: [
  {
    name: editDNtpRErhPUE23a9haLlEuyzw2Vxl_i1M_45fswD8R7fncMeta?.name ?? "companyId-ongevallenregistratie-accidentId-edit",
    path: "edit",
    meta: editDNtpRErhPUE23a9haLlEuyzw2Vxl_i1M_45fswD8R7fncMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/edit.vue")
  },
  {
    name: indexyDDEYpnrtuuYPelNT1cgdWHfuz6aoaxNJtUqoHx80yIMeta?.name ?? "companyId-ongevallenregistratie-accidentId",
    path: "",
    meta: indexyDDEYpnrtuuYPelNT1cgdWHfuz6aoaxNJtUqoHx80yIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/index.vue")
  }
]
  },
  {
    name: achtergrondinformatieMgO7xy5Q83X8KG61n0M2X1D_DMDh7PYfK_45Bvgw6_45FvMMeta?.name ?? "companyId-ongevallenregistratie-achtergrondinformatie",
    path: "achtergrondinformatie",
    meta: achtergrondinformatieMgO7xy5Q83X8KG61n0M2X1D_DMDh7PYfK_45Bvgw6_45FvMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/[companyId]/ongevallenregistratie/achtergrondinformatie.vue")
  }
]
  }
]
  },
  {
    name: request_45link0CXxM1pI1K4nNYVTKY20eOQiYRT_456Ht58LKtnkKH3h8Meta?.name ?? "request-link",
    path: "/request-link",
    meta: request_45link0CXxM1pI1K4nNYVTKY20eOQiYRT_456Ht58LKtnkKH3h8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/request-link.vue")
  },
  {
    name: new6b8AdyfiR38kfuAL8xnIMGbtocxpU0XPBB7ML2M0oFQMeta?.name ?? "companies-new",
    path: "/companies/new",
    meta: new6b8AdyfiR38kfuAL8xnIMGbtocxpU0XPBB7ML2M0oFQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/companies/new.vue")
  },
  {
    name: manage_45catalogshSp7yKuGbuMFG4qti1qAOUwnYbwjiEq2v_UmuS41R8Meta?.name ?? "manage-catalog",
    path: "/manage-catalog",
    meta: manage_45catalogshSp7yKuGbuMFG4qti1qAOUwnYbwjiEq2v_UmuS41R8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/manage-catalog.vue")
  },
  {
    name: index7Z7Pdu_45bEQXxfuOOXte4Co4zxg_45pHnpn7tSNs6CepM8Meta?.name ?? "companies",
    path: "/companies",
    meta: index7Z7Pdu_45bEQXxfuOOXte4Co4zxg_45pHnpn7tSNs6CepM8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/companies/index.vue")
  },
  {
    name: persoonsgegevenshweZKAZOamoEOkinq7ja2onO7pi6SalfwOZsViHOxHgMeta?.name,
    path: "/persoonsgegevens",
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/persoonsgegevens.vue"),
    children: [
  {
    name: edithiHaxw3g6E0QPjKZBvARE8M08M32O0W5Hkt6G_DGkOkMeta?.name ?? "persoonsgegevens-edit",
    path: "edit",
    meta: edithiHaxw3g6E0QPjKZBvARE8M08M32O0W5Hkt6G_DGkOkMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/persoonsgegevens/edit.vue")
  },
  {
    name: indexXrIDYqatrrO_Boyabrwz6YrTQ26KeEqUbu2cR3SkeqgMeta?.name ?? "persoonsgegevens",
    path: "",
    meta: indexXrIDYqatrrO_Boyabrwz6YrTQ26KeEqUbu2cR3SkeqgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/persoonsgegevens/index.vue")
  }
]
  },
  {
    name: vragenlijstPrRY_45osR_45w3XJplx_EB_45WYRoGuDuF_TDVKYtLJICbVIMeta?.name ?? "stigas-vragenlijst",
    path: "/stigas/vragenlijst",
    meta: vragenlijstPrRY_45osR_45w3XJplx_EB_45WYRoGuDuF_TDVKYtLJICbVIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/stigas/vragenlijst.vue")
  },
  {
    name: voorwaarden_45afgewezenKo1wb1SCeeJ_k9d13RcFZQcOg9fbcqvu6NmMKAgVy60Meta?.name ?? "voorwaarden-afgewezen",
    path: "/voorwaarden-afgewezen",
    meta: voorwaarden_45afgewezenKo1wb1SCeeJ_k9d13RcFZQcOg9fbcqvu6NmMKAgVy60Meta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/voorwaarden-afgewezen.vue")
  },
  {
    name: indexfcJaxBh0_45vWRcOjRkHMHFaseGahTYzjRcf6YCGjBkOMMeta?.name ?? "application-users",
    path: "/application-users",
    meta: indexfcJaxBh0_45vWRcOjRkHMHFaseGahTYzjRcf6YCGjBkOMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/application-users/index.vue")
  },
  {
    name: _91userId_93S1AZnTCYuNL7lpifbg2_4503IbEPIY9NpukSSfDq03RoAMeta?.name ?? "application-users-userId",
    path: "/application-users/:userId()",
    meta: _91userId_93S1AZnTCYuNL7lpifbg2_4503IbEPIY9NpukSSfDq03RoAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/application-users/[userId].vue")
  },
  {
    name: uitnodigenRuZkInJwZHOHaME8B68_1hqT5G3N9hH7PCEMs6h9oEgMeta?.name ?? "application-users-uitnodigen",
    path: "/application-users/uitnodigen",
    meta: uitnodigenRuZkInJwZHOHaME8B68_1hqT5G3N9hH7PCEMs6h9oEgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/e-time-bij-gebruikers-van-de-RIE/frontend/pages/application-users/uitnodigen.vue")
  }
]